import React from "react";
import noLogo from "../../../assets/img/brand/noLogo";
import {
  getCompanyDisplayName,
  getCompanyLogoSource,
} from "@dhn/shared/company-info";

export default function CompanyLogo({
  companyInfo,
  loading = false,
  fallback = noLogo,
  alt,
  className = "",
  width,
  height,
  style = {},
  loaderClassName = "",
  loaderStyle = {},
}) {
  if (loading && !companyInfo) {
    return (
      <span
        className={loaderClassName}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: width || undefined,
          height: height || undefined,
          ...loaderStyle,
        }}
        aria-label="Cargando logo"
      >
        <i className="fa fa-spinner fa-spin" aria-hidden="true" />
      </span>
    );
  }

  const companyName = alt || getCompanyDisplayName(companyInfo, "Logo");
  const companyLogo = getCompanyLogoSource(companyInfo, fallback);

  return (
    <img
      src={companyLogo}
      alt={companyName}
      className={className}
      width={width}
      height={height}
      style={style}
    />
  );
}
